// removed by extract-text-webpack-plugin
module.exports = {"workRequestList":"workRequestList__1wyJ1","workRequestItems":"workRequestItems__2l7Xq","formField":"formField__3q7MA","attachment":"attachment__WRkDU","image":"image__P4U4I","exactLocationImage":"exactLocationImage__1NSRG","workRequestImage":"workRequestImage__3yw0s"};


//////////////////
// WEBPACK FOOTER
// ./components/WorkRequests/style.scss
// module id = Rkz1
// module chunks = 1